import { InjectionToken } from '@angular/core';

export interface OneTrust {
  AllowAll: () => void;
  BlockGoogleAnalytics: (e: unknown, t: unknown) => void;
  Close: (e: unknown) => void;
  FetchAndDownloadPC: () => void;
  GetDomainData: () => void;
  Init: (e: unknown) => void;
  InitializeBanner: () => void;
  IsAlertBoxClosed: () => boolean;
  IsAlertBoxClosedAndValid: () => boolean;
  LoadBanner: () => void;
  OnConsentChanged: (e: () => void) => ConsentEvent;
  ReconsentGroups: () => void;
  RejectAll: (e: unknown) => void;
  SetAlertBoxClosed: (e: unknown) => void;
  ToggleInfoDisplay: () => void;
  changeLanguage: (lang: string) => void;
  getDataSubjectId: () => void;
  initializeCookiePolicyHtml: () => void;
  getGeolocationData: () => GeoLocationData;
  setGeoLocation: (e: unknown, t: unknown) => void;
  useGeoLocationService: boolean;
}

export interface GeoLocationData {
  country: string;
  state: string;
}

export interface ConsentEvent extends CustomEvent {
  detail: Array<string>;
}

export interface OneTrustConfig {
  domainScript: string;
  disabled?: boolean;
}

export const ONE_TRUST_CONFIG = new InjectionToken<OneTrustConfig>(
  'Config for One Trust'
);
